module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-lineup-osaka-1-efeca97de639190fa97567d647c4eb18.png";